import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

export type PlayerActivityEvent = {
  id: string;
  playerId: string;
  firstName: string;
  lastName: string;
  displayName: string | null;
  currentTeam: string | null;
  currentLeague: string | null;
  type: 'note' | 'viewing' | 'video' | 'schedule';
  title: string;
  body: string | null;
  occurredAt: number;
  createdAt: number;
  createdBy: string | null;
};

export type PlayerActivityResponse = {
  mode: 'current' | 'archive';
  startAt: number;
  endAt: number;
  days: number;
  total: number;
  items: PlayerActivityEvent[];
};

export function usePlayerActivity(options: { archive?: boolean; days?: number; limit?: number } = {}) {
  const archive = options.archive ?? false;
  const days = options.days ?? 7;
  const limit = options.limit ?? (archive ? 300 : 120);
  return useQuery<PlayerActivityResponse>({
    queryKey: ['players', 'activity', { archive, days, limit }],
    queryFn: () =>
      apiGet<PlayerActivityResponse>(
        `/api/activity/players?days=${days}&limit=${limit}${archive ? '&archive=1' : ''}`
      ),
    staleTime: 10_000,
    refetchInterval: archive ? false : 30_000,
    refetchIntervalInBackground: !archive,
  });
}
